export function download(name: string, text: string, type = 'application/json') {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const anchor = document.createElement('a');

  anchor.href = url;
  anchor.download = name;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const filename = (name: string) =>
  name.replace(/[^a-z0-9._ -]/gi, '_').slice(0, 100) || 'cairn';
